import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = {
    url: String,
    request: String,
  };

  static targets = ['input', 'copy', 'copied'];

  async start() {
    if (!this.urlValue) {
      await this.requestSharedLink();
    }

    if (this.deviceType() != 'desktop' && this.canNativeShare()) {
      this.nativeShare();
    } else {
      this.inputTarget.classList.toggle('hidden');
      this.inputTarget.value = this.urlValue;
      this.inputTarget.select();
      this.inputTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });

      if (this.inputTarget.classList.contains('hidden')) {
        this.copyTarget.classList.add('hidden');
        this.copiedTarget.classList.add('hidden');
      } else {
        this.copyTarget.classList.remove('hidden');
        this.copiedTarget.classList.add('hidden');
      }
    }
  }

  async requestSharedLink() {
    if (!this.requestValue) {
      console.error('Request URL missing!');
      return;
    }

    const request = new FetchRequest('post', this.requestValue);
    const response = await request.perform();
    if (response.ok) {
      const body = await response.json;
      this.urlValue = body.url;
    }
  }

  nativeShare() {
    navigator
      .share(this.shareData())
      .catch((error) => console.error('Sharing failed', error));
  }

  canNativeShare() {
    return navigator.canShare && navigator.canShare(this.shareData());
  }

  copy() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.inputTarget.value);
    } else {
      document.execCommand('copy');
    }

    this.copiedTarget.classList.toggle('hidden');
    this.copyTarget.classList.toggle('hidden');
  }

  shareData() {
    return {
      title: 'AstroDNA',
      // text: 'something to share',
      url: this.urlValue,
    };
  }

  deviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua))
      return 'tablet';
    else if (
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua,
      )
    )
      return 'mobile';

    return 'desktop';
  }
}
